import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DataTable, FlexBox, IconButton, Page, Timestamp, } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
import { composeEmailActions } from 'components/shared/composeEmail/actions/composeEmailActions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
export const DraftsView = () => {
    const dispatch = useAppDispatch();
    const { emailDrafts, meta } = useAppSelector((state) => state.composeEmail);
    const handleEdit = (draft) => {
        dispatch(composeEmailActions.composeEmailOpenModal({
            initialValues: draft,
        }));
    };
    const handleRemove = (draft) => {
        dispatch(composeEmailActions.composeEmailRemoveDraft({
            timestamp: draft.timestamp,
        }));
    };
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: "Email drafts" }), _jsx(Page.Section, { children: _jsx(DataTable, { data: emailDrafts, columns: [
                        {
                            label: 'From',
                            selector: (draft) => {
                                var _a;
                                return (_a = draft.fromEmails) !== null && _a !== void 0 ? _a : _jsx("em", { children: "No sender" });
                            },
                        },
                        {
                            label: 'To',
                            selector: (draft) => {
                                var _a, _b, _c, _d;
                                return (_d = (_c = (_b = (_a = draft.toUser) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : _jsx("em", { children: "No receiver" });
                            },
                        },
                        {
                            label: 'Subject',
                            selector: (draft) => {
                                var _a;
                                return (_a = draft.subject) !== null && _a !== void 0 ? _a : _jsx("em", { children: "No subject" });
                            },
                        },
                        {
                            label: 'Message',
                            selector: (draft) => {
                                var _a;
                                return (_a = draft.message) !== null && _a !== void 0 ? _a : _jsx("em", { children: "No message" });
                            },
                        },
                        {
                            label: 'Created',
                            selector: (draft) => {
                                var _a;
                                return (_jsx(Timestamp, { time: moment((_a = draft.timestamp) !== null && _a !== void 0 ? _a : Date.now()).toISOString(), relative: true }));
                            },
                        },
                        {
                            label: '',
                            selector: (draft) => {
                                return (_jsxs(FlexBox, { children: [_jsx(IconButton, { variant: "tertiary", icon: "pen", onClick: () => handleEdit(draft) }), _jsx(IconButton, { variant: "tertiary", icon: "trash", onClick: () => handleRemove(draft) })] }));
                            },
                            style: {
                                width: 0,
                            },
                        },
                    ], tableStatusProps: {
                        loading: meta.getDrafts === 'loading',
                        emptyState: meta.getDrafts === 'succeeded' && !emailDrafts.length
                            ? {
                                title: 'No email drafts',
                                description: "You haven't saved any email drafts yet.",
                            }
                            : undefined,
                    } }) })] }));
};
